import { createApp } from 'vue';
import getBodyPluginConfig from './index';
import plugin from '../plugins';

export default function getBodyPlugin(params) {
    let { globalData, pageData, globalizationIns } = params;
    let moduleData = pageData.moduleData;
    const app = createApp(getBodyPluginConfig(globalData, moduleData, globalizationIns));
    
    plugin.install(app, params);
    let parentDom = document.createElement('div');
    document.body.appendChild(parentDom);
    app.mount(parentDom);
}